import { render, staticRenderFns } from "./DashboardShipments.vue?vue&type=template&id=03cb0446&scoped=true"
import script from "./DashboardShipments.vue?vue&type=script&lang=js"
export * from "./DashboardShipments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cb0446",
  null
  
)

export default component.exports